import { render, staticRenderFns } from "./TeacherReport.vue?vue&type=template&id=0bb708d1&scoped=true"
import script from "./TeacherReport.vue?vue&type=script&lang=js"
export * from "./TeacherReport.vue?vue&type=script&lang=js"
import style0 from "./TeacherReport.vue?vue&type=style&index=0&id=0bb708d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb708d1",
  null
  
)

export default component.exports